<!-- detail list form -->
<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="20">
                <div>
                    <div class="box">
                        <el-header class="box-title">
                            页面内容
                        </el-header>
                        <el-main class="box-content">
                            <div class="element" v-for="(item, index) in archive.details" :key="index">
                                <el-row :gutter="20">
                                    <el-col :span="20" class="element-title">
                                        <DetailElement :title="item.title" :type="item.type" :sign="item.sign"></DetailElement>
                                    </el-col>
                                    <el-col :span="4" class="element-operator">
                                        <el-button icon="el-icon-caret-top" circle @click="moveUp(index)"></el-button>
                                        <el-button icon="el-icon-caret-bottom" circle @click="moveDown(index)"></el-button>
                                        <el-button icon="el-icon-edit" :class="[item.data == null ? 'empty' : '']" circle @click="edit(index)"></el-button>
                                        <el-button icon="el-icon-delete" circle @click="del(index)"></el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-main>
                        <el-footer class="box-buttons">
                            <el-button type="primary" @click="submit">1. 保存</el-button>
                            <el-button @click="preview">2. 预览</el-button>
                            <el-button type="success" @click="publish">3. 发布</el-button>
                        </el-footer>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <el-container>
                    <el-aside>
                        <el-menu :default-openeds="['1','1-1','1-2', '1-3']">
                            <el-submenu index="1">
                                <template slot="title"><i class="el-icon-orange"></i>组件列表</template>
                                <el-submenu index="1-1">
                                    <template slot="title">元素</template>
                                    <el-menu-item index="1-1-1" @click="add('Grammar')">语法</el-menu-item>
                                    <el-menu-item index="1-1-2" @click="add('Sentence')">例句</el-menu-item>
                                    <el-menu-item index="1-1-3" @click="add('Struct')">结构</el-menu-item>
                                    <el-menu-item index="1-1-4" @click="add('Translation')">文本</el-menu-item>
                                    <el-menu-item index="1-1-5" @click="add('SingleImage')">图片</el-menu-item>
                                    <el-menu-item index="1-1-6" @click="add('BackgroundImage')">背景图片</el-menu-item>
                                    <!-- <el-menu-item index="1-1-2" @click="add('SentenceTranslation')">例句文本</el-menu-item> -->
                                </el-submenu>
                                <el-submenu index="1-2">
                                    <template slot="title">复合组件</template>
                                    <!-- <el-menu-item index="1-2-1" @click="add('Explain')">语法解释</el-menu-item> -->
                                    <!-- <el-menu-item index="1-2-2" @click="add('Sentences')">例句集合</el-menu-item> -->
                                    <!-- <el-menu-item index="1-2-2" @click="add('Frame')">框</el-menu-item> -->
                                </el-submenu>
                                <el-submenu index="1-3">
                                    <template slot="title">其他元素</template>
                                    <!-- <el-menu-item index="1-2-1" @click="add('Tag')">标签</el-menu-item> -->
                                    <el-menu-item index="1-3-1" @click="add('Label')">标记</el-menu-item>
                                    <!-- <el-menu-item index="1-2-2" @click="add('SingleAudio')">音频</el-menu-item> -->
                                </el-submenu>
                            </el-submenu>
                        </el-menu>
                    </el-aside>
                </el-container>
            </el-col>
        </el-row>
        <!-- component dialog -->
        <el-dialog title="组件编辑" :visible.sync="dialogVisible" width="60%" append-to-body>
            <!-- 当detail发生变化时,同步修改archive.details里sign相同的对象 -->
            <component :key="componentId" @closeComponent="closeComponent" :is="detail.type" v-model="detail" :archive="archive" :sign="detail.sign"></component>
        </el-dialog>
    </div>
</template>
<script>
import DetailElement from './DetailElement.vue'
import Grammar from './Grammar.vue'
import Sentence from './Sentence.vue'
import Struct from './Struct.vue'
import SentenceTranslation from './SentenceTranslation.vue'
import Translation from './Translation.vue'
import SingleImage from './SingleImage.vue'
import SingleAudio from './SingleAudio.vue'
import Tag from './Tag.vue'
import Label from './Label.vue'
import Tip from './Tip.vue'
import Sentences from './Sentences.vue'
import Frame from './Frame.vue'
import Explain from './Explain.vue'
import BackgroundImage from './BackgroundImage.vue'
import signMixin from '../mixins/graphic/sign'
import cloneMixin from '../mixins/graphic/clone'
export default {
    name: 'Archive',
    mixins: [signMixin, cloneMixin],
    components: {
        DetailElement,
        Grammar,
        Sentence,
        SentenceTranslation,
        Translation,
        SingleImage,
        SingleAudio,
        Struct,
        Tag,
        Label,
        Tip,
        Sentences,
        Explain,
        BackgroundImage,
        Frame,
    },
    props: {
        value: Object, //固定命名,父组件的model,数据双向绑定
        graphic: Object,
    },
    data() {
        return {
            dialogVisible: false,
            componentId: +new Date(),
            // 当前编辑的组件
            detail: {
                id: null,
                title: null,
                sign: null,
                type: null,
                data: null,
                attributes: [],
            },
            // 可用组件
            types: [
                { title: "语法", type: "Grammar" },
                { title: "例句", type: "Sentence" },
                { title: "结构", type: "Struct" },
                { title: "例句文本", type: "SentenceTranslation" },
                { title: "文本", type: "Translation" },
                { title: "图片", type: "SingleImage" },
                { title: "音频", type: "SingleAudio" },
                { title: "标签", type: "Tag" },
                { title: "标记", type: "Label" },
                { title: "例句集合", type: "Sentences" },
                { title: "语法解释", type: "Explain" },
                { title: "背景图片", type: "BackgroundImage" },
                { title: "框", type: "Frame" },
            ],
            // 文档对象
            archive: {},
        }
    },
    watch: {
        value(newVal, oldVal) {
            this.init()
            // this.reLoad()
        },
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.archive = this.value
            this.load()
        },
        load() {},
        preview() {
            for (var i in this.archive.details) {
                if (this.archive.details[i].type == 'Sentences') {
                    this.archive.details[i].attaches = {
                        title: "例句",
                    }
                }
            }
            var data = window.btoa(encodeURIComponent(JSON.stringify([this.archive])))
            var url = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API + '/graphic/preview' : ' http://192.168.1.93:9090'
            this.openWindow(url + '/index.html?rand=' + Math.random() + '#/?from=backend&data=' + data, 'preview', 375, 667)
        },
        openWindow(url, name, width = null, height = null, top = null, left = null) {
            var pageWidth = window.screen.width
            var pageHeight = window.screen.height
            if (width == null) {
                width = 800
            }
            if (height == null) {
                height = pageHeight - 400
            }
            if (top == null) {
                top = (pageHeight - height) / 2
            }
            if (left == null) {
                left = (pageWidth - width) / 2
            }
            window.open(url, name, 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left)
        },
        newDetail(type) {
            let types = this.types
            var object = null
            for (var i in types) {
                if (types[i].type == type) {
                    object = types[i]
                    break
                }
            }
            object.id = null
            object.sign = this.createSign(13) //唯一标识
            object.data = null
            object.attributes = []
            return object
        },
        add(type) {
            var detail = this.clone(this.newDetail(type))
            this.archive.details.push(detail)
        },
        del(index) {
            this.archive.details.splice(index, 1)
        },
        moveUp(index) {
            if (index == 0) {
                return
            }
            var prev = this.archive.details[index - 1]
            var current = this.archive.details[index]
            this.archive.details.splice(index - 1, 1, current)
            this.archive.details.splice(index, 1, prev)
        },
        moveDown(index) {
            if (index == this.archive.details.length - 1) {
                return
            }
            var next = this.archive.details[index + 1]
            var current = this.archive.details[index]
            this.archive.details.splice(index + 1, 1, current)
            this.archive.details.splice(index, 1, next)
        },
        edit(index) {
            this.componentId = +new Date()
            this.dialogVisible = true
            this.detail = this.archive.details[index]
        },
        submit() {
            for (var i in this.archive.details) {
                var detail = this.archive.details[i]
                if (detail.data == null) {
                    return
                }
            }
            this.$confirm('确认保存？')
                .then(_ => {
                    return this.$http.put(this.$urls.graphic_archive_save, this.archive, {
                        params: { id: this.archive.id }
                    }).then(res => {
                        // 刷新数据
                        this.reLoad();
                    })
                })
                .catch(_ => {});

        },
        reLoad() {
            let params = {
                graphic_id: this.graphic.id
            }
            this.$http.get(this.$urls.graphic_archive_data, { params }).then(res => {
                for (var i in res.data) {
                    if (res.data[i].id == this.archive.id) {
                        this.archive = res.data[i]
                    }
                }
            })
        },
        publish() {
            this.$confirm('确认发布？')
                .then(_ => {
                    return this.$http.put(this.$urls.graphic_archive_publish, this.archive, {
                        params: { id: this.archive.id }
                    }).then(res => {})
                })
                .catch(_ => {});
        },
        closeComponent() {
            this.dialogVisible = false
        },
    },
}
</script>
<style lang="scss">
.box {
    .box-title {
        border-bottom: 1px solid #f5f5f5;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .box-content {
        background-color: white;

        .element {
            border: 1px solid #f5f5f5;
            border-radius: 10px;
            padding: 10px;
            margin: 10px 0px;
            color: #333;

            .element-title {
                height: 40px;
                line-height: 40px;
            }

            .element-operator {
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .empty {
                    border-color: red;
                    color: red;
                }
            }
        }

        .element:hover {
            background-color: #f5f5f5;
        }
    }

    .box-buttons {
        border-top: 1px solid #f5f5f5;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>